const E = {
  READ_MORE: "Läs mer",
  ALL: "Alla",
  CLICK_TO_EXPAND: "Klicka för att expandera",
  CLICK_TO_COLLAPSE: "Klicka för att kollapsa",
  CLICK_TO_PLAY_VIDEO_IN_LARGE_PLAYER: "Klicka för att spela upp video i stor spelare",
  CATEGORY: "Kategori",
  LOCATION: "Ort",
  CLICK_TO_READ_MORE_ABOUT: "Klicka för att läsa mer om",
  YEAR: "År",
  TYPE: "Typ",
  LANGUAGE: "Språk",
  NEWS: "Nyhet",
  NO_MATCHING_RESULTS: "Det finns inga resultat som matchar din filtrering. Testa ändra filtrering!",
  COMING: "Kommer",
  COMING_LATER: "Kommer senare",
  CLICK_TO_DOWNLOAD: "Klicka för att ladda ner",
  SSN: "Personnummer",
  SSN_FORMAT: "ÅÅÅÅMMDDNNNN",
  FIRST_NAME: "Förnamn",
  LAST_NAME: "Efternamn",
  PHONE: "Telefon",
  PHONE_FORMAT: "07NNNNNNNN",
  EMAIL: "E-post",
  STREET_ADDRESS: "Adress",
  ZIPCODE: "Postnummer",
  CITY: "Ort",
  TERMS: "Villkor",
  ACCEPT_TERMS: "Godkänna villkor",
  GO_TO: "Gå till",
  BACK: "Tillbaka",
  CLOSE: "Stäng",
  TODAY: "Idag",
  PLAY_VIDEO: "Spela video",
  PAUSE_VIDEO: "Pausa video",
  NEXT_PAGE: "Nästa sida",
  PREVIOUS_PAGE: "Föregående sida",
  PAGE: "Sida",
  CHANGE: "Ändra",
  GO_NEXT_STEP: "Nästa steg",
  BOOK: "Boka",
  SUMMARY: "Summering",
  PERSONAL_INFORMATION: "Personuppgifter",
  PRICE: "Pris",
  SEK_CURRENCY: "kr",
  DATE_PREFIX: "den",
  SEND: "Skicka",
  SENDING: "Skickar...",
  BOOKING: "Bokar...",
  CANCEL_RESERVATION: "Avboka",
  CANCELLING_RESERVATION: "Avbokar...",
  TIME: "Tid",
  UPLOAD: "Ladda upp",
  NO_FILE_SELECTED: "Ingen fil har valts",
  CLEAR: "Rensa",
  SHOW_RESULTS: "Visa resultat",
  NO_PLEASE: "Nej, tack",
  OPENING_HOURS: "Öppettider",
  VIEW_OFFER: "Se erbjudande",
  CLOSED: "Stängt",
  NAME: "Namn",
  CANCEL: "Avbryt",
  MONDAY: "Måndag",
  FRIDAY: "Fredag",
  SATURDAY: "Lördag",
  SUNDAY: "Söndag",
  TABLE_OF_CONTENTS_TITLE: "På denna sida:",
  ERROR_GENERIC_API_ERROR_HEADING: "Ett fel uppstod",
  ERROR_GENERIC_API_ERROR_BODY: "Ett fel uppstod när vi försökte hämta information. Försök igen senare.",
  ERROR_MISSING_INFORMATION_HEADING: "Det saknas tyvärr uppgifter, korrigera följande och försök igen",
  ERROR_MISSING_INFORMATION: "Det saknas tyvärr uppgifter",
  HEADER_LANGUAGE_SELECTION_ARIA_LABEL: "Språkval",
  HEADER_SEARCH_ARIA_LABEL: "Sök",
  HEADER_MENU_ARIA_LABEL: "Huvudmeny toppen av sidan",
  HEADER_MENU_MOBILE_ARIA_LABEL: "Huvudmeny mobilanvändare, nedre delen av skärmen",
  HEADER_LOGO_LINK_ARIA_LABEL: "Navigera till startsidan",
  HEADER_MENU: "Meny",
  HEADER_HOME: "Hem",
  FOOTER_VISIT_FACEBOOK: "Besök Facebook",
  FOOTER_VISIT_X: "Besök X",
  FOOTER_VISIT_INSTAGRAM: "Besök Instagram",
  FOOTER_VISIT_YOUTUBE: "Besök YouTube",
  FOOTER_VISIT_LINKEDIN: "Besök LinkedIn",
  FOOTER_ARIA_LABEL: "Sidfot",
  BREADCRUMBS_ARIA_LABEL: "Brödsmulor för sidhierarki",
  JOB_AVAILABLE_POSITION: "Ledig tjänst",
  JOB_TITLE: "Tjänst",
  JOB_LOCATION: "Ort",
  JOB_EMPLOYMENT_TYPE: "Anställningstyp",
  JOB_CONTACT: "Kontaktperson",
  JOB_APPLY_HERE: "Ansök här",
  JOB_CTA_HEADING: "Kontaktuppgifter & Ansökan",
  JOB_APPLY_LAST_DAY: "Sista ansökningsdatum",
  LANGAUGE: "Språk",
  LANGUAGE_SV: "Svenska",
  LANGUAGE_EN: "English",
  SEARCH_SEARCH_HERE: "Sök här",
  SEARCH_SEARCH: "Sök",
  SEARCH_IS_LOADING: "Laddar resultat...",
  SEARCH_NOT_SEARCHED_YET: "Sök efter något i sökfältet ovan för att visa resultat",
  SEARCH_RESULTS_FOUND: "resultat hittades",
  SEARCH_GENERAL_ERROR: "Ett fel uppstod. Det gick inte att hämta sökresultat.",
  REPORT_LIST_ANNUAL_REPORTS: "Årliga rapporter",
  REPORT_LIST_INVESTOR_CALL: "Investor Call",
  REPORT_LIST_PUBLISHED_DATE: "Publiceringsdatum",
  REPORT_LIST_REPORT: "Redovisning",
  REPORT_LIST_ANNUAL_REPORT: "Årsredovisning",
  REPORT_LIST_SUSTAINABILITY_REPORT: "Hållbarhetsredovisning",
  REPORT_LIST_INTERIM_REPORT: "Kvartalsrapport",
  CISION_PRM: "Pressmeddelande",
  CISION_INB: "Inbjudan",
  CISION_KMK: "Bokslutskommuniké",
  CISION_NBR: "Nyhet",
  CISION_RDV: "Årsredovisning",
  INPUT_FIELD_REQUIRED: "Obligatoriskt fält",
  INPUT_FIELD_FALLBACK_ERROR_MESSAGE: "Felaktigt ifyllt fält, försök igen.",
  INPUT_FIELD_EMAIL_VALIDATION_FAILED: "Ange en korrekt e-postadress",
  INPUT_FIELD_PHONE_VALIDATION_FAILED: "Ange ett korrekt telefonnummer utan landskod (+46). Tio siffror som börjar med 07.",
  INPUT_FIELD_SSN_VALIDATION_FAILED: "Vänligen fyll enligt formatet ÅÅÅÅMMDDNNNN",
  INPUT_PASSWORD_SHOW_PASSWORD: "Visa lösenord",
  TRAILER_RENTAL_TRAILER_MAX_LOAD: "Max. last",
  TRAILER_RENTAL_TRAILER_TOTAL_WEIGHT: "Tot. vikt",
  TRAILER_RENTAL_TRAILER_MEASUREMENTS_LABEL: "Inv. mått",
  TRAILER_RENTAL_TRAILER_FROM_PRICE_LABEL: "Fr. {{price}} kr",
  TRAILER_RENTAL_TRAILER_NOT_AVAILABLE: "Ej tillgänglig detta datum",
  TRAILER_RENTAL_STATION_SEARCH_LABEL: "Station",
  TRAILER_RENTAL_STATION_SEARCH_NO_OPTIONS: "Inga stationer hittades",
  TRAILER_RENTAL_STATION_SEARCH_PLACEHOLDER: "Sök ort eller station",
  TRAILER_RENTAL_SEARCH_BUTTON_LABEL: "Hitta släp",
  TRAILER_RENTAL_SEARCH_STARTDATE_LABEL: "Hämtas",
  TRAILER_RENTAL_SEARCH_ENDDATE_LABEL: "Lämnas",
  TRAILER_RENTAL_TRAILER_TYPE: "Släptyp",
  TRAILER_RENTAL_EMAIL_CONFIRMATION_HELPER: "Hit skickar vi bokningsbekräftelsen",
  TRAILER_RENTAL_FILTER_TRAILER_LABEL: "Släp ({{numberOfTrailers}} st)",
  TRAILER_RENTAL_FILTER_CAR_TRAILER_LABEL: "Biltrailer ({{numberOfTrailers}} st)",
  TRAILER_RENTAL_FILTER_BOAT_TRAILER_LABEL: "Båttrailer ({{numberOfTrailers}} st)",
  TRAILER_RENTAL_TRAILER_TYPE_FILTER_LABEL: "Filtrera släpkategori",
  TRAILER_RENTAL_TRAILER_LIST_HEADING: "Släp på {{stationName}}",
  TRAILER_RENTAL_TRAILER_LIST_HEADING_NEARBY_TRAILERS: "Släp på andra stationer i närheten av {{stationName}}",
  TRAILER_RENTAL_TRAILER_LIST_TEXT: "Välj släptyp för att visa lediga tider",
  TRAILER_RENTAL_RESERVE_TRAILER: "Reservera släp",
  TRAILER_RENTAL_SELECT_TIMESLOT_FOR_PRICE: "Välj tid för att se pris",
  TRAILER_RENTAL_PRICE_REDUCTION_INCLUDED: "Ink. moms och skadekostnadsreducering",
  TRAILER_RENTAL_BOOKING_COMPLETED_HEADING: "Tack för din bokning",
  TRAILER_RENTAL_BOOKING_COMPLETED_BOOKING_NUMBER_TEXT: "Ditt bokningsnummer är:",
  TRAILER_RENTAL_BOOKING_COMPLETED_EMAIL_TEXT: "Vi har skickat en bokningsbekräftelse till ",
  TRAILER_RENTAL_BOOKING_COMPLETED_EXTRA_INFORMATION: "Anmäl din ankomst i butiken och kom ihåg att hämta ut ditt släp i tid. Vid försening kontakta uthyrande station.",
  TRAILER_RENTAL_CANCELLATION_TITLE: "Avboka hyrsläp",
  TRAILER_RENTAL_CANCELLATION_PREAMBLE: "Ångrat dig? Inga problem, ange ditt bokningsnummer för att avboka online eller kontakta stationen där du bokat.",
  TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_LABEL: "Bokningsnummer",
  TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_HELPER_TEXT: "Numret hittar du i bekräftelsemailet",
  TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_PLACEHOLDER: "8 siffror",
  TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_ERROR_TEXT: "Ange ett korrekt bokningsnummer (8 siffror)",
  TRAILER_RENTAL_CANCELLATION_GET_BOOKING_BUTTON_LABEL: "Hämta bokning",
  TRAILER_RENTAL_CANCELLATION_GET_BOOKING_BUTTON_LABEL_LOADING: "Hämtar bokning... ",
  TRAILER_RENTAL_CANCELLATION_COMPLETE_HEADING: "Avbokning genomförd",
  TRAILER_RENTAL_CANCELLATION_COMPLETE_TEXT: "Bokning med nummer {{bookingNumber}} är nu avbokad!",
  TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_HEADING: "Din bokning: {{bookingId}}",
  TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_STATION_NAME: "Station:",
  TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_PICKUP_TIME: "Hämtas:",
  TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_RETURN_TIME: "Lämnas:",
  TRAILER_RENTAL_ERROR_MUST_SELECT_FROM_TIMESLOT: "Du måste välja en tid för upphämtning",
  TRAILER_RENTAL_ERROR_MUST_SELECT_TO_TIMESLOT: "Du måste välja en tid för återlämning",
  TRAILER_RENTAL_ERROR_MUST_SELECT_TIMESLOT: "Du måste välja en tid för att fortsätta",
  TRAILER_RENTAL_ERROR_FETCH_STATIONS: "Ett fel uppstod vid hämtning av stationer",
  TRAILER_RENTAL_ERROR_FETCH_AVAILABLE_TRAILERS: "Ett fel uppstod vid hämtning av tillgängliga släp",
  TRAILER_RENTAL_ERROR_SELECT_STATION: "Välj en station",
  TRAILER_RENTAL_ERROR_SELECT_FROM_TIMESLOT: "Välj datum för hämtning",
  TRAILER_RENTAL_ERROR_SELECT_TO_TIMESLOT: "Välj datum för lämning",
  TRAILER_RENTAL_ERROR_FROM_BEFORE_TO_TIMESLOT: "Datum för hämtning måste vara före eller samma dag som lämning",
  TRAILER_RENTAL_ERROR_BOOKING_FAILED: "Misslyckades att genomföra bokning",
  TRAILER_RENTAL_ERROR_GET_BOOKING_FAILED: "Något gick fel. Vi kunde tyvärr inte hämta bokningsinformationen.",
  TRAILER_RENTAL_ERROR_POST_BOOKING_CANCELLATION_FAILED: "Något gick fel. Kunde inte avboka",
  TRAILER_RENTAL_LOADING_TRAILERS_LABEL: "Letar efter lediga släp...",
  CONTACT_CARD_AREA_OF_WORK: "Områdesbeskrivning",
  FIND_STATION_STATION_MODAL_ARIA_DESCRIPTION: "Här kan du läsa mer om utbudet och öppettiderna på {{stationName}}.",
  FIND_STATION_OPEN_24_HOURS: "Öppet dygnet runt",
  FIND_STATION_PREEM_MANNED: "Butik",
  FIND_STATION_PREEM_UNMANNED: "Automat",
  FIND_STATION_SAIFA_UNMANNED: "Automat",
  FIND_STATION_OPENING_HOURS_TODAY: "Öppettider idag: {{openingHours}} - {{closingHours}}",
  FIND_STATION_OPENING_HOURS_UNMANNED: "Öppet dygnet runt",
  FIND_STATION_KM_ABBREVIATED: "km",
  FIND_STATION_OPEN_ALL_FILTERS: "Alla filter",
  FIND_STATION_FILTER_MODAL_TITLE: "Filter",
  FIND_STATION_FILTER_MODAL_ARIA_DESCRIPTION: "Här kan du skapa en filtrering för att lättare hitta en station med den tjänst eller drivmedel du letar efter.",
  FIND_STATION_FILTER_GROUP_LABEL_PROPELLANTS: "Drivmedel",
  FIND_STATION_FILTER_GROUP_LABEL_SERVICES: "Tjänster",
  FIND_STATION_FILTER_GROUP_LABEL_ELECTRIC_CHARGING: "Laddning",
  FIND_STATION_FILTER_SUB_GROUP_LABEL_CHARGER_STANDARD: "Uttagstyp",
  FIND_STATION_FILTER_SUB_GROUP_LABEL_CHARGER_EFFECT: "Laddeffekt",
  FIND_STATION_SEARCH_PLACEHOLDER: "Sök stationer",
  FIND_STATION_SERVICE_ESPRESSO_HOUSE: "Espresso House",
  FIND_STATION_SERVICE_ADAPTED_FOR_24M_VEHICLE: "Anpassad för 24m fordon",
  FIND_STATION_SERVICE_CAR_WASH_BOTH: "Biltvätt",
  FIND_STATION_SERVICE_CAR_WASH_AUTOMATIC: "Biltvätt (automat)",
  FIND_STATION_SERVICE_CAR_WASH_SELF_SERVICE: "Biltvätt (tvätta själv)",
  FIND_STATION_SERVICE_FOOD_AND_BEVERAGES: "Mat och dryck",
  FIND_STATION_SERVICE_TRAILER_RENTAL: "Hyrsläp",
  FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL: "Preem Evolution Diesel",
  FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL_PLUS: "Preem Evolution Diesel Plus",
  FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL_FRI_FRAN_RME: "Preem Evolution Diesel utan RME",
  FIND_STATION_FUEL_EVOLUTION_BENSIN_95: "Preem Evolution Bensin",
  FIND_STATION_FUEL_BENSIN_95: "Bensin 95",
  FIND_STATION_FUEL_BENSIN_98: "Bensin 98",
  FIND_STATION_FUEL_HVO100_LIGHT_VEHICLE: "HVO100 Lätt trafik/Personbil",
  FIND_STATION_FUEL_HVO100_HEAVY_VEHICLE: "HVO100 Tung trafik",
  FIND_STATION_FUEL_PREEM_REDEFINE_HVO100_LIGHT_VEHICLE: "Preem Redefine HVO100 Lätt Trafik/Personbil",
  FIND_STATION_FUEL_PREEM_REDEFINE_HVO100_HEAVY_VEHICLE: "Preem Redefine HVO100 Tung Trafik",
  FIND_STATION_FUEL_ETANOL_E85: "Etanol E85",
  FIND_STATION_FUEL_EV_CHARGING: "{{standard}} • {{power}}",
  FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_CHADEMO: "CHAdeMO",
  FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_TYPE2: "Typ 2",
  FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_CCS: "CCS",
  FIND_STATION_FUEL_AD_BLUE: "AdBlue",
  FIND_STATION_FUEL_ACP_DIESEL: "ACP Diesel utan RME",
  FIND_STATION_FUEL_ACP_DIESEL_50: "ACP Diesel 50",
  FIND_STATION_FUEL_ANLAGGNINGSDIESEL: "Anläggningsdiesel",
  FIND_STATION_FUEL_FORDONGAS: "Fordonsgas",
  FIND_STATION_FUEL_LBG_FLYTANDE_BIOGAS: "LBG - Flytande Biogas",
  FIND_STATION_SHOW_MY_LOCATION: "Visa min plats",
  FIND_STATION_GEOLOCATION_CONSENT_TITLE: "Visa din plats på kartan?",
  FIND_STATION_GEOLOCATION_CONSENT_EXPLANATION: "Om du vill se din plats på kartan och se stationer närmast dig i listan behöver du ge Maps åtkomst till din plats i webbläsaren.",
  FIND_STATION_SERVICES_TITLE: "Tjänster",
  FIND_STATION_SERVICES_TEXT: "",
  FIND_STATION_PROPELLANTS_TITLE: "Drivmedel",
  FIND_STATION_PROPELLANTS_TEXT: "",
  FIND_STATION_WELCOME_TO_REFUEL_24_7: "Välkommen att tanka dygnet runt",
  FIND_STATION_TRAILER_RENTAL_CTA: "Reservera hyrsläp",
  FIND_STATION_STORE_OPENING_HOURS: "Butikens öppettider",
  FIND_STATION_DIRECTIONS_CTA: "Vägbeskrivning",
  FIND_STATION_MAP_CLUSTER_LABEL: "Samling av stationer",
  FIND_STATION_POSITION_MARKER_TITLE: "Din position",
  FIND_STATION_LOADING_POSITION_LABEL: "Laddar position...",
  FIND_STATION_LIST_AVAILABLE_ACTIONS_TEXT: "Välj filter, sök station eller använd kartan",
  FIND_STATION_LIST_NO_STATION_MATCH_QUERY: "Din sökning eller filtrering gav inte några träffar i listan på stationer.",
  FIND_STATION_QUICK_FILTERS_SELECTED_FILTERS_LABEL: "Valda filter:",
  FIND_STATION_LIST_TITLE: "Stationer",
  FIND_STATION_LIST_CHARGE_ICON_EXPLANATION: "= Laddning",
  FIND_STATION_SHOW_MORE_STATIONS: "Visa fler stationer"
}, _ = {
  READ_MORE: "Read more",
  ALL: "All",
  CLICK_TO_EXPAND: "Click to expand",
  CLICK_TO_COLLAPSE: "Click to collapse",
  CLICK_TO_PLAY_VIDEO_IN_LARGE_PLAYER: "Click to play video in large player",
  CATEGORY: "Category",
  LOCATION: "Location",
  CLICK_TO_READ_MORE_ABOUT: "Click to read more about",
  YEAR: "Year",
  TYPE: "Type",
  LANGUAGE: "Language",
  NEWS: "News",
  NO_MATCHING_RESULTS: "There are no results matching your filter. Try changing filters!",
  COMING: "Coming",
  COMING_LATER: "Coming later",
  CLICK_TO_DOWNLOAD: "Click to download",
  SSN: "Social security number",
  SSN_FORMAT: "YYYYMMDDNNN",
  FIRST_NAME: "First name",
  LAST_NAME: "Last name",
  PHONE: "Phone",
  PHONE_FORMAT: "07NNNNNNNN",
  EMAIL: "Email",
  STREET_ADDRESS: "Address",
  ZIPCODE: "Zipcode",
  CITY: "City",
  TERMS: "Terms",
  ACCEPT_TERMS: "Accept terms",
  GO_TO: "Go to",
  BACK: "Back",
  CLOSE: "Close",
  TODAY: "Today",
  PLAY_VIDEO: "Play video",
  PAUSE_VIDEO: "Pausa video",
  NEXT_PAGE: "Next page",
  PREVIOUS_PAGE: "Previous page",
  PAGE: "Page",
  CHANGE: "Change",
  GO_NEXT_STEP: "Next step",
  BOOK: "Book",
  SUMMARY: "Summary",
  PERSONAL_INFORMATION: "Personal information",
  PRICE: "Price",
  SEK_CURRENCY: "kr",
  DATE_PREFIX: "",
  SEND: "Send",
  SENDING: "Sending...",
  BOOKING: "Confirming booking...",
  CANCEL_RESERVATION: "Cancel booking",
  CANCELLING_RESERVATION: "Confirming cancellation...",
  TIME: "Time",
  UPLOAD: "Upload",
  NO_FILE_SELECTED: "No file selected",
  CLEAR: "Clear",
  SHOW_RESULTS: "Show results",
  NO_PLEASE: "No, please",
  OPENING_HOURS: "Opening Hours",
  VIEW_OFFER: "View offer",
  CLOSED: "Closed",
  CANCEL: "Cancel",
  NAME: "Name",
  MONDAY: "Monday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
  TABLE_OF_CONTENTS_TITLE: "On this page:",
  ERROR_GENERIC_API_ERROR_HEADING: "An error occurred",
  ERROR_GENERIC_API_ERROR_BODY: "An error occurred when trying to fetch information. Please try again later.",
  ERROR_MISSING_INFORMATION_HEADING: "Information is missing in some fields, adjust and try again",
  ERROR_MISSING_INFORMATION: "Information is missing",
  HEADER_LANGUAGE_SELECTION_ARIA_LABEL: "Language selection",
  HEADER_SEARCH_ARIA_LABEL: "Search",
  HEADER_MENU_ARIA_LABEL: "Top Menu, top of the page",
  HEADER_MENU_MOBILE_ARIA_LABEL: "Main menu mobile users, bottom part of the screen",
  HEADER_LOGO_LINK_ARIA_LABEL: "Navigate to start page",
  HEADER_MENU: "Menu",
  HEADER_HOME: "Home",
  FOOTER_VISIT_FACEBOOK: "Visit Facebook",
  FOOTER_VISIT_X: "Visit X",
  FOOTER_VISIT_INSTAGRAM: "Visit Instagram",
  FOOTER_VISIT_YOUTUBE: "Visit YouTube",
  FOOTER_VISIT_LINKEDIN: "Visit LinkedIn",
  FOOTER_ARIA_LABEL: "Footer",
  BREADCRUMBS_ARIA_LABEL: "Breadcrumbs for page hierarchy",
  JOB_AVAILABLE_POSITION: "Available position",
  JOB_TITLE: "Job Title",
  JOB_LOCATION: "Location",
  JOB_EMPLOYMENT_TYPE: "Employment Type",
  JOB_CONTACT: "Contact",
  JOB_APPLY_HERE: "Apply here",
  JOB_CTA_HEADING: "Contact & Application",
  JOB_APPLY_LAST_DAY: "Last date to apply",
  LANGAUGE: "Language",
  LANGUAGE_SV: "Svenska",
  LANGUAGE_EN: "English",
  SEARCH_SEARCH_HERE: "Search here",
  SEARCH_SEARCH: "Sök",
  SEARCH_IS_LOADING: "Loading results...",
  SEARCH_NOT_SEARCHED_YET: "Search by typing something in the search field above",
  SEARCH_RESULTS_FOUND: "results found",
  SEARCH_GENERAL_ERROR: "An error occurred. Could not fetch search results.",
  REPORT_LIST_ANNUAL_REPORTS: "Annual reports",
  REPORT_LIST_INVESTOR_CALL: "Investor Call",
  REPORT_LIST_PUBLISHED_DATE: "Published date",
  REPORT_LIST_REPORT: "Report",
  REPORT_LIST_ANNUAL_REPORT: "Annual Report",
  REPORT_LIST_SUSTAINABILITY_REPORT: "Sustainability Report",
  REPORT_LIST_INTERIM_REPORT: "Interim Report",
  CISION_PRM: "Press release",
  CISION_INB: "Invite",
  CISION_KMK: "Year-end report",
  CISION_NBR: "News",
  CISION_RDV: "Annual report",
  INPUT_FIELD_REQUIRED: "Required field",
  INPUT_FIELD_FALLBACK_ERROR_MESSAGE: "Incorrectly filled field, please try again.",
  INPUT_FIELD_EMAIL_VALIDATION_FAILED: "Not a correctly formated email address",
  INPUT_FIELD_PHONE_VALIDATION_FAILED: "Please provide a correctly formated phone number",
  INPUT_FIELD_SSN_VALIDATION_FAILED: "Please provide the following format YYYYMMDDNNNN",
  INPUT_PASSWORD_SHOW_PASSWORD: "Show password",
  TRAILER_RENTAL_TRAILER_MAX_LOAD: "",
  TRAILER_RENTAL_TRAILER_TOTAL_WEIGHT: "",
  TRAILER_RENTAL_TRAILER_MEASUREMENTS_LABEL: "",
  TRAILER_RENTAL_TRAILER_FROM_PRICE_LABEL: "",
  TRAILER_RENTAL_TRAILER_NOT_AVAILABLE: "",
  TRAILER_RENTAL_STATION_SEARCH_LABEL: "",
  TRAILER_RENTAL_STATION_SEARCH_NO_OPTIONS: "",
  TRAILER_RENTAL_STATION_SEARCH_PLACEHOLDER: "",
  TRAILER_RENTAL_SEARCH_BUTTON_LABEL: "",
  TRAILER_RENTAL_SEARCH_STARTDATE_LABEL: "",
  TRAILER_RENTAL_SEARCH_ENDDATE_LABEL: "",
  TRAILER_RENTAL_TRAILER_TYPE: "",
  TRAILER_RENTAL_EMAIL_CONFIRMATION_HELPER: "",
  TRAILER_RENTAL_FILTER_TRAILER_LABEL: "Trailer ({{numberOfTrailers}} st)",
  TRAILER_RENTAL_FILTER_CAR_TRAILER_LABEL: "Car trailer ({{numberOfTrailers}} st)",
  TRAILER_RENTAL_FILTER_BOAT_TRAILER_LABEL: "Boat trailer ({{numberOfTrailers}} st)",
  TRAILER_RENTAL_TRAILER_TYPE_FILTER_LABEL: "Select trailer type",
  TRAILER_RENTAL_TRAILER_LIST_HEADING: "Trailers at {{stationName}}",
  TRAILER_RENTAL_TRAILER_LIST_HEADING_NEARBY_TRAILERS: "Trailers at other stations nearby {{stationName}}",
  TRAILER_RENTAL_TRAILER_LIST_TEXT: "Välj släptyp för att visa lediga tider",
  TRAILER_RENTAL_RESERVE_TRAILER: "Reserve trailer",
  TRAILER_RENTAL_SELECT_TIMESLOT_FOR_PRICE: "Select timeslots to see the price",
  TRAILER_RENTAL_PRICE_REDUCTION_INCLUDED: "",
  TRAILER_RENTAL_BOOKING_COMPLETED_HEADING: "Thank you for your reservation",
  TRAILER_RENTAL_BOOKING_COMPLETED_BOOKING_NUMBER_TEXT: "Your reservation number is:",
  TRAILER_RENTAL_BOOKING_COMPLETED_EMAIL_TEXT: "We have sent a confirmation of your reservation to",
  TRAILER_RENTAL_BOOKING_COMPLETED_EXTRA_INFORMATION: "Notify the station of your arrival and don't forget to collect your trailer on time. In case of delay, please contact the station you are picking up the trailer from.",
  TRAILER_RENTAL_CANCELLATION_TITLE: "Cancel Trailer Rental",
  TRAILER_RENTAL_CANCELLATION_PREAMBLE: "Changed your mind? No problem, enter your booking number to cancel online or contact the station where you booked.",
  TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_LABEL: "Booking Number",
  TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_HELPER_TEXT: "You can find the number in the confirmation email",
  TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_PLACEHOLDER: "8 digits",
  TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_ERROR_TEXT: "Enter a correct booking number (8 digits)",
  TRAILER_RENTAL_CANCELLATION_COMPLETE_HEADING: "Cancellation complete",
  TRAILER_RENTAL_CANCELLATION_COMPLETE_TEXT: "Reservation with number {{bookingNumber}} is now cancelled.",
  TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_HEADING: "Your reservation: {{bookingId}}",
  TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_STATION_NAME: "Station:",
  TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_PICKUP_TIME: "Pick up:",
  TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_RETURN_TIME: "Return:",
  TRAILER_RENTAL_CANCELLATION_GET_BOOKING_BUTTON_LABEL: "Retrieve Booking",
  TRAILER_RENTAL_CANCELLATION_GET_BOOKING_BUTTON_LABEL_LOADING: "Retrieving booking... ",
  TRAILER_RENTAL_ERROR_MUST_SELECT_FROM_TIMESLOT: "You must select a time for pickup",
  TRAILER_RENTAL_ERROR_MUST_SELECT_TO_TIMESLOT: "You must select a time for return",
  TRAILER_RENTAL_ERROR_MUST_SELECT_TIMESLOT: "You must select timeslots to continue",
  TRAILER_RENTAL_ERROR_FETCH_STATIONS: "An error occurred when trying to fetch stations",
  TRAILER_RENTAL_ERROR_FETCH_AVAILABLE_TRAILERS: "An error occurred when trying to fetch available trailers",
  TRAILER_RENTAL_ERROR_SELECT_STATION: "Select a station",
  TRAILER_RENTAL_ERROR_SELECT_FROM_TIMESLOT: "Select date for pickup",
  TRAILER_RENTAL_ERROR_SELECT_TO_TIMESLOT: "Select date for return",
  TRAILER_RENTAL_ERROR_FROM_BEFORE_TO_TIMESLOT: "Pickup date must be before or the same as return date",
  TRAILER_RENTAL_ERROR_BOOKING_FAILED: "Misslyckades att genomföra bokning",
  TRAILER_RENTAL_ERROR_GET_BOOKING_FAILED: "Something went wrong. Unfortunately, we could not retrieve the booking information.",
  TRAILER_RENTAL_ERROR_POST_BOOKING_CANCELLATION_FAILED: "Something went wrong. Could not cancel the booking",
  TRAILER_RENTAL_LOADING_TRAILERS_LABEL: "Looking for available trailers...",
  CONTACT_CARD_AREA_OF_WORK: "Area of work",
  FIND_STATION_STATION_MODAL_ARIA_DESCRIPTION: "Here you can read more about the offerings and opening hours at {{stationName}}.",
  FIND_STATION_OPEN_24_HOURS: "Open 24 hours",
  FIND_STATION_PREEM_MANNED: "Preem Manned",
  FIND_STATION_PREEM_UNMANNED: "Preem Automated",
  FIND_STATION_SAIFA_UNMANNED: "SÅIFA",
  FIND_STATION_OPENING_HOURS_TODAY: "Open today until {{closingHours}}",
  FIND_STATION_OPENING_HOURS_UNMANNED: "Open 24/7",
  FIND_STATION_KM_ABBREVIATED: "km",
  FIND_STATION_OPEN_ALL_FILTERS: "All filters",
  FIND_STATION_FILTER_MODAL_TITLE: "Filter",
  FIND_STATION_FILTER_MODAL_ARIA_DESCRIPTION: "Här kan du skapa en filtrering för att lättare hitta en station med den tjänst eller drivmedel du letar efter.",
  FIND_STATION_FILTER_GROUP_LABEL_PROPELLANTS: "Propellants",
  FIND_STATION_FILTER_GROUP_LABEL_SERVICES: "Services",
  FIND_STATION_FILTER_GROUP_LABEL_ELECTRIC_CHARGING: "Electric Charging",
  FIND_STATION_FILTER_SUB_GROUP_LABEL_CHARGER_STANDARD: "Charger type",
  FIND_STATION_FILTER_SUB_GROUP_LABEL_CHARGER_EFFECT: "Wattage",
  FIND_STATION_SEARCH_PLACEHOLDER: "Search stations",
  FIND_STATION_SERVICE_ESPRESSO_HOUSE: "Espresso House",
  FIND_STATION_SERVICE_ADAPTED_FOR_24M_VEHICLE: "Adapter for 24m vehicles",
  FIND_STATION_SERVICE_CAR_WASH_BOTH: "Biltvätt",
  FIND_STATION_SERVICE_CAR_WASH_AUTOMATIC: "Car Wash Automatic",
  FIND_STATION_SERVICE_CAR_WASH_SELF_SERVICE: "Car Wash Self Service",
  FIND_STATION_SERVICE_FOOD_AND_BEVERAGES: "Food & beverages",
  FIND_STATION_SERVICE_TRAILER_RENTAL: "Trailer rental",
  FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL: "Preem Evolution Diesel",
  FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL_PLUS: "Preem Evolution Diesel Plus",
  FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL_FRI_FRAN_RME: "Preem Evolution Diesel (RME free)",
  FIND_STATION_FUEL_EVOLUTION_BENSIN_95: "Evolution Bensin 95",
  FIND_STATION_FUEL_BENSIN_95: "Petrol 95",
  FIND_STATION_FUEL_BENSIN_98: "Petrol 98",
  FIND_STATION_FUEL_HVO100_LIGHT_VEHICLE: "HVO 100 - Light Vehicle",
  FIND_STATION_FUEL_HVO100_HEAVY_VEHICLE: "HVO 100 - Heavy Vehicle",
  FIND_STATION_FUEL_PREEM_REDEFINE_HVO100_LIGHT_VEHICLE: "Preem Redefine HVO100 Light Vehicle",
  FIND_STATION_FUEL_PREEM_REDEFINE_HVO100_HEAVY_VEHICLE: "Preem Redefine HVO100 Heavy Vehicle",
  FIND_STATION_FUEL_ETANOL_E85: "Ethanol E85",
  FIND_STATION_FUEL_EV_CHARGING: "{{standard}} • {{power}}",
  FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_CHADEMO: "CHAdeMO",
  FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_TYPE2: "Type 2",
  FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_CCS: "CCS",
  FIND_STATION_FUEL_AD_BLUE: "AdBlue",
  FIND_STATION_FUEL_ACP_DIESEL: "ACP Diesel",
  FIND_STATION_FUEL_ACP_DIESEL_50: "ACP Diesel 50",
  FIND_STATION_FUEL_ANLAGGNINGSDIESEL: "Anläggningsdiesel",
  FIND_STATION_FUEL_FORDONGAS: "Vehicle gas",
  FIND_STATION_FUEL_LBG_FLYTANDE_BIOGAS: "LBG Flytande Biogas",
  FIND_STATION_SHOW_MY_LOCATION: "Show my location",
  FIND_STATION_GEOLOCATION_CONSENT_TITLE: "Display your location on map?",
  FIND_STATION_GEOLOCATION_CONSENT_EXPLANATION: "If you want to see your location on the map and the closest stations you need to give the browser access to your location.",
  FIND_STATION_SERVICES_TITLE: "Services",
  FIND_STATION_SERVICES_TEXT: "",
  FIND_STATION_PROPELLANTS_TITLE: "Propellants",
  FIND_STATION_PROPELLANTS_TEXT: "",
  FIND_STATION_WELCOME_TO_REFUEL_24_7: "Welcome to refuel 24/7",
  FIND_STATION_TRAILER_RENTAL_CTA: "Reserve trailer",
  FIND_STATION_STORE_OPENING_HOURS: "Store opening hours",
  FIND_STATION_DIRECTIONS_CTA: "Directions",
  FIND_STATION_MAP_CLUSTER_LABEL: "Cluster of stations",
  FIND_STATION_POSITION_MARKER_TITLE: "Your position",
  FIND_STATION_LOADING_POSITION_LABEL: "Loading your position...",
  FIND_STATION_LIST_AVAILABLE_ACTIONS_TEXT: "Select a filter, search station or browse the map",
  FIND_STATION_LIST_NO_STATION_MATCH_QUERY: "Your search term or filter didn't match any stations",
  FIND_STATION_QUICK_FILTERS_SELECTED_FILTERS_LABEL: "Selected filters:",
  FIND_STATION_LIST_TITLE: "Stations",
  FIND_STATION_LIST_CHARGE_ICON_EXPLANATION: "= Charging station",
  FIND_STATION_SHOW_MORE_STATIONS: "Show more stations"
}, T = {
  ..._,
  CLOSE: "Menü schließen",
  HEADER_MENU: "Menü öffnen"
}, A = {
  sv: E,
  en: _,
  de: T
};
export {
  A as default
};
